import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation StartSignUp($enquiry: EnquiryInput!) {
    startSignUp(enquiry: $enquiry) {
      uuid
      status
      stage
      enquiry {
        firstName
        lastName
        emailAddress
        leadId
        licences
        middleName
        companyName
      }
      expiry
    }
  }
`
export const startSignUpKey = getQueryNames(mutation)[0]

export default mutation
